var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsPinBooked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84892 3.94954C2.25782 5.64764 1.26122 8.12129 1.29992 10.448C1.38073 15.3102 3.57236 17.1508 7.07718 23.8426C8.33967 26.7873 9.65735 29.9032 10.9106 35.0637C11.0847 35.8249 11.2546 36.532 11.3332 36.5933C11.4117 36.6546 11.5816 35.945 11.7558 35.1838C13.009 30.0232 14.3267 26.9099 15.5892 23.9652C19.094 17.2733 21.2856 15.4327 21.3664 10.5705C21.4051 8.24379 20.406 5.76766 18.8149 4.06956C16.9974 2.12977 14.2559 0.694173 11.3332 0.634142C8.41043 0.574072 5.66649 2.00974 3.84892 3.94954Z",
    fill: "#50B733",
    stroke: "#235016",
    strokeWidth: 1.26462
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 14.4675C13.4533 14.4675 15.172 12.7489 15.172 10.6288C15.172 8.50867 13.4533 6.79001 11.3332 6.79001C9.21309 6.79001 7.49438 8.50867 7.49438 10.6288C7.49438 12.7489 9.21309 14.4675 11.3332 14.4675Z",
    fill: "#235016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 37.2185,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsPinBooked);
export default __webpack_public_path__ + "static/media/maps-pin-Booked.d22e0d2c35e512cf9bc33921239224f2.svg";
export { ForwardRef as ReactComponent };